module.exports = __webpack_public_path__ + "assets/img/contact.fddbe05f.svg";